module.exports = __webpack_public_path__ + "img/about.0179c25c.svg";